import React from "react";
import {
  getUserRecord,
  updateUserRecord
} from "./connection/firebase-users.js";
import store from "../init/store.js";
import { setCrewValue } from "../redux-actions/battle-actions.js";
import { getUserUnlocks } from "../b5-unlocks/getUserUnlocks.js";
import { compareUnlocksStates } from "../b5-unlocks/compareUnlocksStates.js";
import {getBattleType} from './get-battle-type'

class BattleResultProcessingLoader extends React.Component {
  constructor() {
    super();
    this.state = {
      isDoneProcessing: false, //This is the flag for knowing the Firebase work is done.

      isDoneAnimating: false, //This is the flag for knowing the little animation sequence is complete.
      animationBarProgress: 0 //Flips to 100 after a moment. CSS will bring us there.
      //Both of these must get set to TRUE before we fire the callback.
    };
  }

  //Watch for both processes to complete
  componentWillUpdate(newProps, newState) {
    if (newState.isDoneAnimating && newState.isDoneProcessing) {
      this.props.onDone();
    }
  }

  //After a moment, trigger the bar to start filling.
  componentDidMount() {
    setTimeout(() => {
      this.setState({ animationBarProgress: 100 });
    }, 200);
  }

  componentWillMount() {
    //Get info for updating our user record.
    const winOrLose = store.getState().matchmaking.matchResult;
    const battleType = getBattleType();

    //Get the current user data
    getUserRecord(data => {
      // console.log('user data', data);

      //Save a copy of our previous unlocks
      const unlocksBeforeUpdate = getUserUnlocks();

      //update the user record with this result
      updateUserRecord(data, winOrLose, battleType, result => {
        //Do something with the result;
        //Save it to local state
        setCrewValue({
          record: { ...result.payload }
        });

        //Get a new version of our unlocks so we can compare to our old
        //This will allow us to show what has been achieved after this battle.

        const unlocksAfterUpdate = getUserUnlocks();
        const newUnlocks = compareUnlocksStates(
          unlocksBeforeUpdate,
          unlocksAfterUpdate
        );

        //Pass our ne unlocks up the the parent component
        this.props.provideNewUnlocks(newUnlocks);

        //Tell our loader bar that we're actually ready to fire be done
        this.setState({
          isDoneProcessing: true
        });
      });
    });
  }

  handleTransitionEnd() {
    this.setState({
      isDoneAnimating: true
    });
  }

  render() {
    const titleStyle = {
      textAlign: "center",
      marginBottom: "3em"
    };

    const containerBarStyle = {
      position: "relative",
      width: "100%",
      height: "1.8em",
      background: "#485471",
      outline: "0.5em solid #200535"
    };
    const fillProgressStyle = {
      position: "absolute",
      background: "#DBE2F6",
      borderBottom: "0.4em solid #CAD1E6",
      left: 0,
      bottom: 0,
      top: 0,
      width: `${this.state.animationBarProgress}%`,
      transition: "width 1.1s ease-in"
    };

    return (
      <div>
        <div style={titleStyle}>Processing</div>
        <div style={containerBarStyle}>
          <div
            style={fillProgressStyle}
            onTransitionEnd={this.handleTransitionEnd.bind(this)}
          />
        </div>
      </div>
    );
  }
}

export default BattleResultProcessingLoader;



// WEBPACK FOOTER //
// ./src/battle/BattleResultProcessingLoader.js